import styled from 'styled-components';

export const Container = styled.div`
  color: #555555;

  a,
  a:link,
  a:visited,
  a:active {
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.blue6};
    font-weight: 700;

    text-decoration: underline;
  }

  ul,
  ol {
    padding-left: 1.25rem;

    p {
      margin-bottom: 0;
    }
  }
`;
